import React, { useState, useEffect } from "react";
import numeral from "numeral";
import { scroller } from "react-scroll";

import { useFetch } from "../utilities";
import "./Counter.css";
import Logo from "./assets/logo.png";

const total = 4717396;

export default function Counter() {
  const count = useFetch("/count");

  const [counting, setCounting] = useState(0);
  useEffect(() => {
    let loop = setInterval(() => {
      if (counting + 100000 <= count) {
        setCounting(counting + 100000);
      } else if (counting + 10000 <= count) {
        setCounting(counting + 10000);
      } else if (counting + 1000 <= count) {
        setCounting(counting + 1000);
      } else if (counting + 100 <= count) {
        setCounting(counting + 100);
      } else if (counting + 10 <= count) {
        setCounting(counting + 10);
      } else if (counting + 1 <= count) {
        setCounting(counting + 1);
      }
    }, 50);

    return function clean() {
      clearInterval(loop);
    };
  }, [count, counting]);

  if (!count) {
    return (
      <div className="Counter">
        <div className="Counter-wrapper">
          <img className="Counter-logo" src={Logo} alt="Compteur RIP" />
          <div className="Counter-block">
            <div className="Counter-load">
              <i className="fas fa-spin fa-compass" />
            </div>
          </div>
        </div>
        <a
          href="#checkname"
          className="Counter-down"
          onClick={handleScrollDown}
        >
          <i className="fas fa-chevron-down" />
        </a>
      </div>
    );
  }

  const percent = (count * 100) / total;

  function handleScrollDown(e) {
    e.preventDefault();
    scroller.scrollTo("checkname", {
      duration: 800,
      smooth: true
    });
    document.getElementById("firstname").focus();
  }

  return (
    <div className="Counter">
      <div className="Counter-wrapper">
        <img className="Counter-logo" src={Logo} alt="Compteur RIP" />
        <div className="Counter-block">
          <div className="Counter-counting">
            {numeral(counting).format("0,0")} <span>signataires</span>
          </div>
          <div className="Counter-border">
            <div style={{ width: `${percent}%` }}>
              <div className="Counter-filled">
                <span>{numeral(percent).format("0.00")}%</span>
              </div>
            </div>
            <div className="Counter-goal">4,7 MILLIONS</div>
          </div>
        </div>
      </div>
      <a href="#checkname" className="Counter-down" onClick={handleScrollDown}>
        <i className="fas fa-chevron-down" />
      </a>
    </div>
  );
}
